import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import makeInviteRoommateLink from 'common/util/makeInviteRoommateLink';
import copyToClipboard from 'copy-to-clipboard';
import branch from 'client/core/branch';

@branch({
  appRedirectionDomainUrl: ['env', 'APP_REDIRECTION_DOMAIN_URL'],
})
class SrInviteRoommateBlock extends Component {
  static propTypes = {
    currentUser: PropTypes.object.isRequired,
    listing: PropTypes.object.isRequired,
    appRedirectionDomainUrl: PropTypes.string.isRequired,
  }

  constructor(props) {
    super(props);
    this.state = {
      clicked: false,
    };
    this._unmounting = false;
  }

  componentWillUnmount() {
    this._unmounting = true;
  }

  _onTextBarClick = (e) => {
    const { currentUser, listing, appRedirectionDomainUrl } = this.props;
    e.preventDefault();
    e.stopPropagation();

    const inviteLink = makeInviteRoommateLink({
      withProtocol: true,
      user: currentUser,
      listing: listing,
      appUrl: appRedirectionDomainUrl,
    });

    copyToClipboard(inviteLink);

    this.setState({
      clicked: false,
    });
    setTimeout(() => {
      if (!this._unmounting) {
        this.setState({
          clicked: true,
        });
      }
    }, 50);
  }

  render() {
    const { currentUser, listing, appRedirectionDomainUrl } = this.props;
    const { clicked } = this.state;

    const inviteLink = makeInviteRoommateLink({
      withProtocol: false,
      user: currentUser,
      listing: listing,
      appUrl: appRedirectionDomainUrl,
    });
    return (
      <div
        onClick={this._onTextBarClick}
        className={classnames(
          'inviteContainer',
          clicked && 'clicked',
        )}
      >
        <div className='formMessage success'>
          <span>Copied link, send it to your roommates!</span>
        </div>
        <p className='invitePrompt'>Invite a roommate to apply, copy & paste this link:</p>
        <div className='linkContainer'>
          <p className='linkCopy'>
            {inviteLink}
          </p>
        </div>
      </div>
    );
  }
}

SrInviteRoommateBlock.displayName = 'SrInviteRoommateBlock';

export default SrInviteRoommateBlock;
